module.exports = __webpack_public_path__ + "static/media/3.0cb2f8a8.png";